/** Layout principal : sidebar fixe en desktop, drawer en mobile. */

import { useState } from 'react';
import { Menu } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Sidebar } from './Sidebar';
import { ChangePasswordModal } from '../shared/ChangePasswordModal';
import { authApi } from '../../services/api';

export function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const { data: me, refetch: refetchMe } = useQuery({
    queryKey: ['me'],
    queryFn: () => authApi.me(),
    staleTime: 60_000,
  });
  const mustChange = me?.must_change_password ?? false;

  return (
    <div className="flex min-h-screen bg-canvas">
      <div className="hidden md:flex">
        <Sidebar />
      </div>

      {mobileOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/40 md:hidden"
            onClick={() => setMobileOpen(false)}
          />
          <div className="fixed inset-y-0 left-0 z-50 md:hidden">
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <div className="md:hidden flex items-center gap-3 px-4 py-3 bg-sidebar text-white shadow">
          <button
            onClick={() => setMobileOpen(true)}
            className="p-1.5 rounded hover:bg-sidebar-hover"
            aria-label="Ouvrir le menu"
          >
            <Menu size={20} />
          </button>
          <span className="font-semibold tracking-wide">PointBreak</span>
        </div>

        <main className="flex-1 p-4 md:p-8 overflow-auto">
          <Outlet />
        </main>
      </div>

      {/* Modale mot de passe bloquante uniquement si mdp par défaut encore actif.
          Le changement volontaire se fait désormais sur la page /profile. */}
      <ChangePasswordModal
        open={mustChange}
        forced
        onClose={() => {}}
        onSuccess={() => refetchMe()}
      />
    </div>
  );
}
